// JavaScript Document
//components/signs/stats/Histogram.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip'
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
   // minWidth: 650,
	maxHeight:'calc(100vh - 84px)',
	//maxHeight: '100%'
  },
});


export default function Histogram(props) {
	const classes = useStyles();
	const {items} = props;
	
	const to12hour = (hour) => {
		if(hour < 12)
			return hour+'am';
		if(hour === 12)
			return '12pm';
		return (hour - 12)+'pm';
	}
	
	if(items.length === 0)
		return '';

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table stickyHeader aria-label="histogram data">
        <TableHead>
          <TableRow>
            <TableCell>Day</TableCell>
	  		<TableCell>Hour</TableCell>
	  		<Tooltip title="Fastest speed recorded" arrow><TableCell>Max</TableCell></Tooltip>
            <Tooltip title="Average speed over percentile" arrow><TableCell>Average Speed</TableCell></Tooltip>
	  		<Tooltip title="Total counts exceeding percentile" arrow><TableCell>Total Speeders</TableCell></Tooltip>
	  		<TableCell>Standard deviation</TableCell>
	  		<TableCell>Speed Limit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row, i) => (
            <TableRow hover role="checkbox" key={i}>
              	<TableCell component="th" scope="row">
                	{row.weekday.substring(0, 1).toUpperCase()+row.weekday.substring(1)}
              	</TableCell>
				<TableCell>{to12hour(row.hour)}</TableCell>
				<TableCell>{row.highest_speed}</TableCell>
				<TableCell>{row.average_mph_over_percentile}</TableCell>
	  			<TableCell>{row.total_exceeding_percentile}</TableCell>
				<TableCell>{row.standard_deviation}</TableCell>
				<TableCell>{row.speed_limit}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
